import { render, staticRenderFns } from "./PCAnswerCard.vue?vue&type=template&id=396a6e60&"
import script from "./PCAnswerCard.vue?vue&type=script&lang=js&"
export * from "./PCAnswerCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports